<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <img class="page-logo" src="@/assets/home/9.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>指纹吉凶测算</span>
    </div>
    <div class="text">
      <p>
        指纹吉凶测算,俗语有云:一斗穷,二斗富,三斗四斗卖豆腐,五斗六斗开当铺,七斗八斗坐着走,九斗十斗享清福。其中的斗指的是箩纹,可以通过你的指纹判定一生运势。
      </p>
    </div>

    <div class="zw">
      <div>
        <div class="zw-img">
          <img src="@/assets/home/liuwen.png" alt="" />
        </div>
        <p>流纹</p>
      </div>
      <div>
        <div class="zw-img">
          <img src="@/assets/home/luowen.png" alt="" />
        </div>
        <p>萝纹</p>
      </div>
    </div>

    <div class="sex">
      <div :class="{ action: sex == 1 }" @click="sex = 1">男</div>
      <div :class="{ action: sex == 0 }" @click="sex = 0">女</div>
    </div>

    <div class="select-zw">
      <div>
        <div>大拇指</div>
        <div class="switch">
          <div :class="{ action: one == 0 }" @click="one = 0">流纹</div>
          <div :class="{ action: one == 1 }" @click="one = 1">萝纹</div>
        </div>
      </div>
    </div>
    <div class="select-zw">
      <div>
        <div>食指</div>
        <div class="switch">
          <div :class="{ action: two == 0 }" @click="two = 0">流纹</div>
          <div :class="{ action: two == 1 }" @click="two = 1">萝纹</div>
        </div>
      </div>
    </div>
    <div class="select-zw">
      <div>
        <div>中食</div>
        <div class="switch">
          <div :class="{ action: three == 0 }" @click="three = 0">流纹</div>
          <div :class="{ action: three == 1 }" @click="three = 1">萝纹</div>
        </div>
      </div>
    </div>
    <div class="select-zw">
      <div>
        <div>无名食</div>
        <div class="switch">
          <div :class="{ action: four == 0 }" @click="four = 0">流纹</div>
          <div :class="{ action: four == 1 }" @click="four = 1">萝纹</div>
        </div>
      </div>
    </div>
    <div class="select-zw">
      <div>
        <div>小拇指</div>
        <div class="switch">
          <div :class="{ action: five == 0 }" @click="five = 0">流纹</div>
          <div :class="{ action: five == 1 }" @click="five = 1">萝纹</div>
        </div>
      </div>
    </div>

    <!-- <div style="height: 3rem"></div> -->
    <div class="start-btn" @click="start">开始测算</div>
    <shareBottomComp v-if="share == 1"></shareBottomComp>

  </div></div>
</template>

<script>
/**
@description:指纹吉凶
@createTime:2021-08-26
@create:wq
*/
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
import topTab from "@/components/topTab";

export default {
  name: "",
  props: {},
  components: {shareBottomComp,topTab},
  data() {
    return {
      sex: 1,
      one: 0,
      two: 0,
      three: 0,
      four: 0,
      five: 0,
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'指纹吉凶',
        path:'/zwjx'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('zwjx','指纹吉凶','','',HERF+'/image/9.png')
  },
  methods: {
    start() {
      const { sex, one, two, three, four, five } = this;
      this.api.fingerprint({ sex, one, two, three, four, five }).then((res) => {
        console.log(res);
        localStorage.setItem("result", JSON.stringify(res.data));
        this.$router.push("/zwjxres");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.sex {
  //   padding: 0 0.34rem;
  margin: 0.46rem 0;
  height: 0.8rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: fixed;
  //   bottom: 1.2rem;
  //   left: 50%;
  //   transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}

.zw {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0.3rem;

  .zw-img {
    width: 1.2rem;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
    }
  }
  p {
    font-size: 0.3rem;
    font-weight: bold;
    color: #666666;
    text-align: center;
    margin-top: 4px;
  }
}
.select-zw {
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.2rem;
  }
  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;

  .switch {
    width: 3.3rem;
    height: 0.6rem;
    border-radius: 0.4rem;
    box-sizing: border-box;
    background: #f0f0f0;
    overflow: hidden;

    font-size: 0.28rem;
    font-weight: 400;
    color: #4fd9d5;
    display: flex;
    > div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .action {
      color: #ffffff;
      background: #4fd9d5;
    }
  }
}
</style>
